
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateItemGroupDtoFormGroup() {
return new FormGroup({
    parentId: new FormControl<number | undefined>(undefined),
    childId: new FormControl<number | undefined>(undefined),
    budgetPrice: new FormControl<number | undefined>(undefined),
})
;
}
      